import { Type } from "class-transformer";
import { CalendarEventStartRelativeTo } from "./CalendarEventStartRelativeTo";
import { CalendarEventTemplateRole } from "./CalendarEventTemplateRole";
import { CustomInitializer } from "src/modules/sm-base/shared/custom-initializer.interface";
import { Objects } from "src/modules/utils/shared/objects";
import { CalendarEventReminderType } from "./CalendarEventReminderType";

export class CalendarEventTemplate implements CustomInitializer {
    //netgen start
    title: string;
    description: string;
    typeId = 0;
    isMilestone = true;
    onlyWeekdays = false;
    startRelativeTo: CalendarEventStartRelativeTo = CalendarEventStartRelativeTo.startDate;
    startRelativeDays = 0;
    allDay = true;
    durationDays = 1;
    startTime = 0;
    endTime = 0;
    workingTime = 0;
    forStandalone = false;
    subTasks: string[];
    contactPersonRoleId: number = null;
    @Type(() => CalendarEventTemplateRole)
    roles: CalendarEventTemplateRole[];
    reminderType: CalendarEventReminderType = CalendarEventReminderType.none;
    reminderDeltaMinutes = 0;
    id = 0;
    //netgen end
    
    constructor() {
        this.customInitializer();
    }

    customInitializer(): void {
        this.subTasks ??= [];
        this.roles ??= [];
    }

    getStringRepresentation(): string {
        return this.title;
    }

    getStartDateComparable(): string {
        return Objects.toString(this.startRelativeTo) + Objects.toString(this.startRelativeDays + 1_000_000).padStart(10, "0");
    }

}
